<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="信用年度">
              <j-input placeholder="" v-model="queryParam.tyear" :trim="true"></j-input>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="信用季度">
              <a-select v-model="queryParam.quarter" placeholder="请选择">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option value="第一季度">第一季度</a-select-option>
                <a-select-option value="第二季度">第二季度</a-select-option>
                <a-select-option value="第三季度">第三季度</a-select-option>
                <a-select-option value="第四季度">第四季度</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="信用类型">
              <j-dict-select-tag v-model="queryParam.type" placeholder="" dictCode="credit_type"/>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="信用时间">
              <j-input placeholder="" v-model="queryParam.date" :trim="true"></j-input>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item label="企业名称">
              <j-input placeholder="" v-model="queryParam.companyName" :trim="true"></j-input>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading">

      </a-table>
    </div>
  </a-card>
</template>

<script>
  import { FzisListMixin } from '@/mixins/FzisListMixin'
  import JInput from '@/components/fzis/JInput'
  import { mapGetters } from 'vuex'
  import JTreeSelect from '@/components/fzis/JTreeSelect'
  import { putAction } from '@api/manage'

  export default {
    name: 'TmCreditList',
    mixins: [FzisListMixin],
    components: {
      JInput,
      JTreeSelect
    },
    data() {
      return {
        description: '项目管理',
        // 查询条件
        queryParam: {},
        disableMixinCreated: true,
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: '',
            key: 'rowIndex',
            width: 50,
            align: 'center',
            customRender: function(t, r, index) {
              return parseInt(index) + 1
            }
          },
          {
            title: '年份',
            align: 'left',
            width:60,
            dataIndex: 'tyear'
          },
          {
            title: '季度',
            align: 'left',
            dataIndex: 'quarter',
            width:60,
          },
          {
            title: '类型',
            align: 'left',
            dataIndex: 'type',
            width:80,
          },
          {
            title: '企业名称',
            align: 'left',
            dataIndex: 'companyName',
            width:200,
          },
          {
            title: '企业社会信用代码',
            align: 'center',
            dataIndex: 'companyCode',
            width:100
          },
          {
            title: '分数',
            align: 'center',
            dataIndex: 'totalSc',
            width:60
          },
          {
            title: '排名',
            align: 'center',
            dataIndex: 'companyRank',
            width:60
          },
          {
            title: '时间',
            align: 'center',
            dataIndex: 'date',
            width:100,
          },
          {
            title: '创建时间',
            align: 'center',
            dataIndex: 'createTime',
            width:150,
          }
        ],
        url: {
          list: '/ebid-ce/tmCredit/list',
          exportXlsUrl: 'ebid-ce/tmCredit/exportXls'
        }
      }
    },
    computed: {
      importExcelUrl: function() {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      }
    },
    methods: {
      ...mapGetters(['username', 'nickname', 'userInfo'])
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';

  .projectTitle{
    color: #595959;
  }

  .projectTitle a{
    color: #595959;
  }

  .projectTitle a:hover{
    color: #118AEC;
  }
</style>